export enum InterpolationMethod {
    Nearest = 'nearest',
    Bilinear = 'bilinear',
    Cubic = 'cubic',
    Lanczos = 'lanczos',
    Average = 'average',
    Rms = 'rms',
    Mode = 'mode',
}
